import dayjs from 'dayjs';
import { ITariff } from 'app/shared/model/tariff.model';
import { ContractType } from 'app/shared/model/enumerations/contract-type.model';
import { Variant } from 'app/shared/model/enumerations/variant.model';
import { CommercialBusiness } from 'app/shared/model/enumerations/commercial-business.model';

export interface ITariffHistory {
  id?: number;
  tariff?: number | null;
  effectiveDate?: dayjs.Dayjs | null;
  expirationDate?: dayjs.Dayjs | null;
  supplierId?: number | null;
  contractType?: keyof typeof ContractType | null;
  variant?: keyof typeof Variant | null;
  commercialBusiness?: keyof typeof CommercialBusiness | null;
  tariffType?: ITariff | null;
}

export const defaultValue: Readonly<ITariffHistory> = {};
